import { getPath } from '@/router/common'

const baseUrl = {
  title: '修改密码',
  path: 'toggleSite'
}

export default [
  {
    path: getPath('ChangePassword', baseUrl),
    name: 'ChangePassword',
    component: () => import(/* webpackChunkName: "ChangePassword" */ '@/views/toggleSite/changePassword/index.vue'),
    meta: {
      title: '修改密码'
    }
  },
  {
    path: getPath('Index', baseUrl),
    name: 'toggleSite_Index',
    component: () => import(/* webpackChunkName: "toggleSite_Index" */ '@/views/toggleSite/index/index.vue'),
    meta: {
      title: '切换站点'
    }
  }
]
